import { motion } from 'framer-motion';

const BackIcon = ({ ...props }) => (
  <motion.svg width={9} height={16} viewBox='0 0 9 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M8 1L1 8L8 15' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </motion.svg>
);

export default BackIcon;
